<template>
	<div class="card">

		<div class="float-right" style="font-size:12px;width:60%">
			'Initial' full & audit trial evacuations are due between 7 and 30 days with no email reminder sent within the last 90 days.
			'Follow Up' full trial evacuations are due within 14 days, or overdue up to 7 days with no emails reminder sent in the last 14 to 90 days.
			'Overdue' full trial evacuations are overdue 1 week or more with no email reminder sent in the last 7 days. Overdue audit trial evacuations are overdue 1 day or more with no email reminder sent in the last 7 days.
			Overdue audit trial evacuation notfications cc site contact if email automation is enabled. Trial evacuations due in more than 90 days are not included.
		</div>

		<h2>Outbound Trial Evacuation Emails</h2>

		<OutboundEmailList emailModuleType="evac" dueDateColumnHeader="Evac Due" />

	</div>
</template>

<script lang="ts">

</script>